import React, { useState, useEffect } from 'react';
import sectiondata from '../../data/sections.json';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';
import { GetPropertyList, searchProperty } from '../../request/apiRquest';

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useLocation } from 'react-router-dom';
import { Spin } from 'antd';




export const SearchGrid = () => {

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false
  };

  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [bhkType, setBhkType] = useState(null);
  const searchParams = new URLSearchParams(window.location.search);


  const [propertylist, setPropertyList] = useState([]);

  const [propertyFor, setPropertyFor] = useState(searchParams.get('PropertyFor'));
  const [selectBuildingType, setSelectedBuildingType] = useState(searchParams.get('PropertyType'));
  const [selectedConstructionType, setSelectedConstructionType] = useState(searchParams.get('Ready_Underconstruction'));
  const [selectBHK, setSelectedBHK] = useState(searchParams.get('BHKType'));
  const [selectMinRange, setSelectedMinRange] = useState(
    Number(searchParams.get('MinPrice')) || 1000
  );
  const [selectMaxRange, setSelectedMaxRange] = useState(
    Number(searchParams.get('MaxPrice')) || 1000000000
  );
  const [selectCity, setSelectedCity] = useState(searchParams.get('Cities'))
  const [selectStates, setSelectedStates] = useState(searchParams.get('States'));



  const getPropertyList = async () => {
    setLoading(true);
    try {
      let filters = {}
      if (propertyFor) filters.PropertyFor = propertyFor;
      if (selectBuildingType) filters.PropertyType = selectBuildingType;
      if (selectedConstructionType) filters.Ready_Underconstruction = selectedConstructionType;
      if (selectBHK) filters.BHKType = selectBHK;
      if (selectMinRange) filters.MinPrice = selectMinRange;
      if (selectMaxRange) filters.MaxPrice = selectMaxRange;
      if (selectCity) filters.Cities = selectCity;
      if (selectStates) filters.States = selectStates;


      const response = await searchProperty(filters);
      setPropertyList(response);
    } catch (error) {
      console.error("Error properties is not show ", error);
    } finally {
      setLoading(false);
    }
  };

  const setQueryParams = (key, value) => {
    searchParams.set([key], value)
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, '', newUrl); // updates the URL without reload
  }

  const handleResetFilter = (e) => {
    e.preventDefault();
    window.history.replaceState(null, '', window.location.pathname)
    setPropertyFor('')
    setSelectedBuildingType('')
    setSelectedConstructionType('')
    setSelectedBHK('')
    setSelectedMaxRange('');
    setSelectedMinRange('');
    setSelectedCity('');
    setSelectedStates('');


  }
  useEffect(() => {
    getPropertyList()
  }, [
    propertyFor,
    selectBuildingType,
    selectedConstructionType,
    selectBHK,
    selectMaxRange,
    selectMinRange,
    selectCity,
    selectStates
  ])



  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'

  return <div className="search-page-wrap pd-top-100 pd-bottom-70">
    <div className="search-container">
      <div className="container">
        <div className="row">
          <div className="col-xl-3 col-lg-4 sitebar">
            <h6 className="filter-title mb-4"><img className="mr-3" src={publicUrl + "assets/img/icons/18.png"} alt="img" />Filter</h6>
            <form className="widget widget-sidebar-search-wrap">
              <div className="widget-sidebar-search">
                <div className="title">Property For</div>
                <div className="widget-sidebar-item-wrap btn-area" style={{ display: "flex", gap: "10px" }}>
                  <a className={`btn ${propertyFor == 1 ? "btn-yellow text-white" : ""} `} onClick={(e) => {
                    e.preventDefault();
                    setQueryParams('PropertyFor', "1")
                    setPropertyFor("1");
                  }}>Buy</a>
                  <a className={`btn ${propertyFor == 2 ? "btn-yellow text-white" : ""} `} onClick={(e) => {
                    e.preventDefault();
                    setQueryParams('PropertyFor', "2")
                    setPropertyFor('2')
                  }}>Rent</a>
                </div>

                <div className="title">Building type</div>
                <div className="widget-sidebar-item-wrap btn-area" style={{ display: "flex", flexWrap: "wrap", gap: "2px" }}>
                  <a className={`btn ${selectBuildingType == 2 ? "btn-yellow text-white" : ""} `} onClick={(e) => {
                    e.preventDefault();
                    setQueryParams('PropertyType', "2")
                    setSelectedBuildingType('2');
                  }}>Apartment</a>
                  <a className={`btn ${selectBuildingType == 1 ? "btn-yellow text-white" : ""} `} onClick={(e) => {
                    e.preventDefault();
                    setQueryParams('PropertyType', "1")
                    setSelectedBuildingType('1');
                  }}>Independent House /Villa</a>
                </div>

                <div className="widget-sidebar-item-wrap rld-single-select">
                  <select value={selectedConstructionType} placeholder='Select Construction Type' onChange={(e) => {
                    setQueryParams('Ready_Underconstruction', e.target.value)
                    setSelectedConstructionType(e.target.value)
                  }} className="select single-select">
                    <option value="1">Ready To move</option>
                    <option value="2">Off Plan</option>
                  </select>
                </div>

                <div className="title">BHK Type</div>
                <div className="widget-sidebar-item-wrap btn-area" style={{ display: "flex", gap: "2px", flexWrap: "wrap" }}>
                  <a className={`btn ${selectBHK == "1BHK" ? "btn-yellow text-white" : ""} `}
                    onClick={(e) => {
                      e.preventDefault();
                      setQueryParams("BHKType", "1BHK")
                      setSelectedBHK('1BHK');
                    }}

                  >1BHK</a>
                  <a className={`btn ${selectBHK == "2BHK" ? "btn-yellow text-white" : ""} `} onClick={(e) => { e.preventDefault(); setQueryParams("BHKType", "2BHK"); setSelectedBHK('2BHK'); }} >2BHK</a>
                  <a className={`btn ${selectBHK == "3BHK" ? "btn-yellow text-white" : ""} `} onClick={(e) => { e.preventDefault(); setQueryParams("BHKType", "3BHK"); setSelectedBHK('3BHK'); }} >3BHK</a>
                  <a className={`btn ${selectBHK == "4BHK" ? "btn-yellow text-white" : ""} `} onClick={(e) => { e.preventDefault(); setQueryParams("BHKType", "4BHK"); setSelectedBHK('4BHK'); }} >4BHK</a>
                </div>
                {/* <div className="widget-sidebar-item-wrap rld-single-input left-icon">
                  <input type="text" placeholder="Entry Landmark Location" />
                </div> */}


                {/* <div className="widget-sidebar-item-wrap rld-single-select">
                  <select className="select single-select">
                    <option value={1}>All Properties</option>
                    <option value={2}>Properties 1</option>
                    <option value={3}>Properties 2</option>
                    <option value={3}>Properties 3</option>
                  </select>
                </div> */}

                <div className="widget-sidebar-item-wrap rld-price-slider-wrap">
                  <div className="title">Any Price</div>
                  <div className="price">
                    {/* <span>AED {selectMinRange}</span> */}

                  </div>
                  {/* <div className="rld-price-slider"> */}
                  <div className="mb-2">
                    <label htmlFor="maxRange" className="form-label">Min Price</label>
                    <span className="float-right">AED {selectMinRange}</span>
                    <input
                      type="range"
                      className="form-range"
                      id="minRange"
                      min={1000}
                      max={selectMaxRange} // optional limit
                      step={50}
                      value={selectMinRange}

                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (value <= selectMaxRange) {
                          setSelectedMinRange(value);
                          setQueryParams("MinPrice", value);
                        }

                      }}
                    // style={{ color: "orange"}}
                    />
                  </div>
                  {/* </div> */}

                  <div className="mb-2">
                    <label htmlFor="maxRange" className="form-label">Max Price</label>
                    <span className="float-right">AED {selectMaxRange}</span>
                    <input
                      type="range"
                      className="form-range"
                      id="maxRange"
                      min={selectMinRange} // optional limit
                      max={10000000000}
                      step={50}
                      value={selectMaxRange}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        if (value >= selectMinRange) {
                          setSelectedMaxRange(value);
                          setQueryParams("MaxPrice", value);
                        }
                      }}
                    />
                  </div>
                </div>
                {/* <div className="widget-sidebar-item-wrap rld-price-slider-wrap">
                  <div className="title">Size</div>
                  <div className="price">
                    <span>600</span>
                    <span className="float-right">6500sqf</span>
                  </div>
                  <div className="rld-size-slider">
                    <div className="ui-slider-handle-size ui-slider-handle" />
                  </div>
                </div> */}
                {/* <div className="widget-sidebar-item-wrap rld-single-select-wrap">
                  <div className="title d-inline-block float-left mb-0 pt-2">Bedroom</div>
                  <div className="rld-single-select d-inline-block float-right">
                    <select className="select single-select">
                      <option value={1}>2-4</option>
                      <option value={2}>3-4</option>
                      <option value={3}>1-3</option>
                      <option value={3}>2-4</option>
                    </select>
                  </div>
                </div> */}
                {/* <div className="widget-sidebar-item-wrap rld-single-select-wrap">
                  <div className="title d-inline-block float-left mb-0 pt-2">Bathroom</div>
                  <div className="rld-single-select d-inline-block float-right">
                    <select className="select single-select">
                      <option value={1}>2-4</option>
                      <option value={2}>3-4</option>
                      <option value={3}>1-3</option>
                      <option value={3}>2-4</option>
                    </select>
                  </div>
                </div> */}
                {/* <div className="widget-sidebar-item-wrap rld-single-select-wrap mb-0">
                  <div className="title d-inline-block float-left mb-0 pt-2">Parking</div>
                  <div className="rld-single-select d-inline-block float-right">
                    <select className="select single-select">
                      <option value={1}>2-4</option>
                      <option value={2}>3-4</option>
                      <option value={3}>1-3</option>
                      <option value={3}>2-4</option>
                    </select>
                  </div>
                </div> */}
              </div>
              <div className="btn-wrap text-center">
                <button onClick={handleResetFilter} className="btn btn-yellow"><span className="left"><i className="fa fa-search" /></span>Reset Filter</button>
              </div>
            </form>
          </div>
          <div className="col-xl-9 col-lg-8">
            <div className="row mb-3">
              <div className="col-md-9 col-sm-8" style={{ display: "flex", gap: "25px" }}>
                <h6 className="filter-title mt-3 mb-lg-0"> Total-Properties : {propertylist?.length}</h6>
              </div>
              {/* <div className="col-md-3 col-sm-4">
                <div className="rld-single-select">
                  <select className="select single-select">
                    <option value={1}>Tile View</option>
                    <option value={2}>Tile View 1</option>
                    <option value={3}>Tile View 2</option>
                    <option value={3}>Tile View 3</option>
                  </select>
                </div>
              </div> */}
            </div>
            {loading ? (
              //<div className="text-center">Loading properties...</div>
              <div className="text-center py-5">                
                <Spin size="large" tip="Loading properties..."/>
              </div>
            ) : (
              <>
                <div className="row justify-content-center">
                  {propertylist?.length > 0 ? (
                    propertylist?.map((item, index) => {
                      const images = item?.image || [];

                      return (
                        <div key={index} className="col-xl-4 col-sm-6">
                          <div className="single-feature">
                            <div className="thumb">
                              {images.length > 1 ? (
                                <Slider {...carouselSettings}>
                                  {images.map((img, index) => (
                                    <div key={index}>
                                      <img
                                        src={img?.src}
                                        alt={`Property ${index}`}
                                        className="img-fluid property-image"
                                        //  style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                                        style={{
                                          height: '250px',
                                          width: '100%',
                                          objectFit: 'cover',
                                          imageRendering: 'auto',
                                          display: 'block',
                                          backfaceVisibility: 'hidden',
                                          transform: 'translateZ(0)', // Helps with sharp rendering on some devices
                                          WebkitBackfaceVisibility: 'hidden'
                                        }}
                                      />
                                    </div>
                                  ))}
                                </Slider>
                              ) : (
                                <div>
                                  <img src={images[0]?.src} alt="property" className="img-fluid"
                                    style={{ height: '250px', objectFit: 'cover', width: '100%' }}
                                  />
                                </div>
                              )}
                            </div>

                            <div className="details">
                              {/* <a href="#" className="feature-logo">
                              <img src={publicUrl + item.icon} alt={imagealt} />
                            </a> */}
                              {/* <p className="author"><i className="fa fa-user" />{item.name || 'Unknown'}</p> */}
                              <h6 className="title readeal-top"><Link to={item.url}>{item.name}</Link></h6>
                              <h6 className="title readeal-top" style={{ fontSize: "12px" }}><Link to={item.url}>{item.building_type}</Link></h6>
                              <h6 className="price">
                                {item.price}
                                {item.olderprice && <del> {item.olderprice}</del>}
                              </h6>
                              <ul className="info-list">
                                <li key={index}><i className="fa fa-bed" /> {item.bhk_type}</li>
                                <li><img src={"/assets/img/icons/7.png"} alt={imagealt} /> {item.builtup_area}</li>
                              </ul>
                              <ul className="contact-list">
                                <li className="readeal-top"><Link className="btn btn-yellow"
                                  //  to={item.url}
                                  to={`/property-details/${item.id}`}
                                >View Details</Link></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <div className="col-12 text-center">
                      <p>No properties found matching your criteria.</p>
                    </div>
                  )}
                </div>
                {/* Pagination */}
                {/* {propertylist.length < propertylist.length && (
                  <div className="property-filter-menu portfolio-filter text-center mb-3">
                    <button
                      className="btn btn-yellow"
                      onClick={loadMore}
                      disabled={loading}
                    >
                      {loading ? 'Loading...' : 'Load More'}
                    </button>
                  </div>
                )} */}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>


}

export default SearchGrid